import AppConfig from "../helpers/config";

const BASE_URL = AppConfig.baseApiURL;
const BASE_CMS_URL = AppConfig.baseCMSApiURL;

export const API_HOME_PACKAGE_TYPES = `${BASE_URL}/GeniusTravelSingular/GetGeniusTravelPackageTypes`;
export const API_SEARCH_ONLY_LISTING = `${BASE_URL}/GeniusTravelSingular/SearchOnlyListing`;
export const API_SEARCH_PACKAGE_DETAIL = `${BASE_URL}/GeniusTravelSingular/GetPackageDetails`;
export const API_SEARCH_MORE_FLIGHTS = `${BASE_URL}/GeniusTravelCommon/MoreFlightsSearch`;

// auth
export const API_LOGIN = `${BASE_URL}/GeniusTravelProfile/GetUserProfile`;
export const API_REGISTER = `${BASE_URL}/GeniusTravelProfile/InsertUserProfile`;
export const API_UPDATE_PROFILE = `${BASE_URL}/GeniusTravelProfile/UpdateUserProfile`;
export const API_GET_SEARCHED_AIRPORTS = `${BASE_URL}/GeniusTravelSingular/SearchAirports`;
export const API_GET_SEARCHED_AIRPORTS_CODES = `${BASE_URL}/GeniusTravelCommon/SearchAirports`;
export const API_RESET_PASSWORD = `${BASE_URL}/GeniusTravelProfile/ResetPassword`;
export const API_DELETE_ACCOUNT = `${BASE_URL}/GeniusTravelProfile/DeleteUserProfile`;
// export const API_VALIDATE_AUTH = `https://geniustravelsociallogin.cherimoya.be/api/ExternalAuth/Validate`;

// Favorites
export const GET_FAVORITES = `${BASE_URL}/GeniusTravelProfile/GetFavorites`;
export const DELETE_FAVORITES = `${BASE_URL}/GeniusTravelProfile/DeleteFavorite`;
export const INSERT_FAVORITES = `${BASE_URL}/GeniusTravelProfile/InsertFavorite`;

// communication
// export const INSERT_CUSTOMER_FEEDBACK = `${BASE_URL}/GeniusTravelCommunication/InsertCustomerFeedback`
export const API_GET_FAQ = `${BASE_URL}/GeniusTravelCommunication/GetFAQ`

// Dev API
export const API_GET_APP_TRANSLATION = `${AppConfig.baseCMSApiURL}`;

// app apis
export const API_GET_BEST_DATES_CALENDER = `${BASE_URL}/GeniusTravelCommon/GetBestTravelDates`;
export const API_GET_COUNTRY_SEARCH_LISTING = `${BASE_URL}/GeniusTravelCommon/smartLookup`;
export const API_GET_TRANSACTION_ID = `${BASE_URL}/GeniusTravelCommunication/CreateTransactionId`;
export const API_POST_PUNCH_OUT_TO_EXTERNAL = `${BASE_URL}/GeniusTravelSingular/PunchOutToExternal`;
export const API_GET_CLOSEST_AIRPORT = `${BASE_URL}/GeniusTravelSingular/GetClosestAirport`;

// Notification apis
export const API_POST_DEVICE_TOKEN_PARAMS = `${BASE_CMS_URL}/devices/register`;
export const API_POST_USER_OBJECT = `${BASE_CMS_URL}/users`;
export const API_GET_USER_SEARCH_LIST = `${BASE_CMS_URL}/user-searches?external_user_id=`;
export const API_POST_USER_SEARCH_PAYLOAD = `${BASE_CMS_URL}/user-searches`;
export const API_GET_NOTIFICATION_LIST = `${BASE_CMS_URL}/notifications`;
export const API_DELETE_SEARCH_HISTORY = `${BASE_CMS_URL}/user-searches/bulk-delete`;

// CMS static content (about us, press, vacancies, legal pages, FAQs).
// These were previously built inline at seven call sites with raw axios.
export const API_GET_CMS_PAGES = `${BASE_CMS_URL}/pages`;
export const API_GET_CMS_FAQS = `${BASE_CMS_URL}/faqs`;

// ChatGPT
export const API_POST_QUERY_MESSAGE_CHATGPT = `${BASE_URL}/GeniusTravelGPT/GeniusChatGPT`;

// Social login validation — hosted separately from the main API, so it has its
// own environment-driven base URL rather than a literal at the call site.
export const API_SOCIAL_AUTH_VALIDATE = `${AppConfig.socialAuthBaseURL}/api/ExternalAuth/Validate`;
export const API_SOCIAL_AUTH_SDK_VALIDATE = `${AppConfig.socialAuthBaseURL}/api/ExternalAuth/SdkValidate`;
